import { enc, SHA256 } from 'crypto-js';
import { getUserId, getUserEmail, getLoggedUserEmailId } from '../auth';

export const sha256Encryption = inputString => {
  const hash = SHA256(inputString).toString();
  const hexResult = hash.toString(enc.Hex);
  return hexResult;
};

export const FA_PREFIX =
  'e723d02598a21f41cf45b26381397e928fd0d7695262e75208bf532496260597ca12b12b21e410e7b1c36232bb6450c8977cf6e7e7e3592535352ffcb91b9d86e723d02598a21f41cf45b26381397e928fd0d7695262e75208bf532496260597bc7331f153631b2b122379bdd7e282edd23f0b3b81ef9dda6109100de284e7a3';

export const getLoggedUserInfo = () => {
  const domainSplitter = '.com';
  const nonFedEmail = getUserEmail();
  const fedEmail = getLoggedUserEmailId();
  const loggedUserEmail = !nonFedEmail ? fedEmail : nonFedEmail;
  const domainNameValue = loggedUserEmail?.split('@')[1];
  const selectedDomainName = sha256Encryption(
    `${FA_PREFIX}${domainNameValue?.split(domainSplitter)[0]}`,
  );
  const userIdValue = sha256Encryption(
    `${getUserId()}${domainNameValue?.split(domainSplitter)[0]}`,
  );
  return {
    domainName: selectedDomainName,
    userId: userIdValue,
  };
};

// Centralized keys used to look up entries in `firebaseAnalyticsPageIds`.
// Use these constants when calling `accessAnalyticsCode` with a static page
// reference, so that page identifiers are not duplicated as magic strings
// across the codebase.
export const firebaseAnalyticsPageKeys = {
  HOME: 'HOME',
  SEARCH: 'SEARCH',
  CREATE_EVENT: 'CREATE_EVENT',
  EVENT: 'EVENT',
  FAVORITES: 'FAVORITES',
  RECENTLY_VIEWED: 'RECENTLY_VIEWED',
  PREFERENCES: 'PREFERENCES',
  HELP_CENTER: 'HELP_CENTER',
  TRENDS_VIEW_EQUIPMENT: 'TRENDS_VIEW_EQUIPMENT',
  TRENDS_VIEW_OPPORTUNITY: 'TRENDS_VIEW_OPPORTUNITY',
  TRENDS_VIEW: 'TRENDS_VIEW',
  SITE_LIST: 'SITE_LIST',
  MAP_LIST: 'MAP_LIST',
  SITE_LIST_REPORT: 'SITE_LIST_REPORT',
  SITE_DETAILS_AIS_ACTIVE: 'site-details/ais/active',
  SITE_DETAILS_PAI_ACTIVE: 'site-details/pai/active',
  LIVE_CONNECT: 'live-connect',
  TEMPERATURE_AND_CONSUMPTION: 'temperature-and-consumption',
  EQUIPMENT_DETAILS_PAI_DETAILS: 'equipment-details/pai/details',
  EQUIPMENT_DETAILS_PAI_HISTORY: 'equipment-details/pai/history',
  TMM: 'TMM',
  PDF_REPORT: 'PDF_REPORT',
  INVENTORY_REPORT: 'INVENTORY_REPORT',
};

export const firebaseAnalyticsPageIds = {
  [firebaseAnalyticsPageKeys.HOME]: {
    pageId: 'PORTFOLIO_SCREEN',
  },
  [firebaseAnalyticsPageKeys.SEARCH]: {
    pageId: 'SITE_SEARCH_SCREEN',
  },
  [firebaseAnalyticsPageKeys.CREATE_EVENT]: {
    pageId: 'CREATE_EVENT_SCREEN',
  },
  [firebaseAnalyticsPageKeys.EVENT]: {
    pageId: 'EVENTS_SCREEN',
  },
  [firebaseAnalyticsPageKeys.FAVORITES]: {
    pageId: 'FAVORITES_SCREEN',
  },
  [firebaseAnalyticsPageKeys.RECENTLY_VIEWED]: {
    pageId: 'RECENTLY_VIEWED_SCREEN',
  },
  [firebaseAnalyticsPageKeys.PREFERENCES]: {
    pageId: 'PREFERENCES_SCREEN',
  },
  [firebaseAnalyticsPageKeys.HELP_CENTER]: {
    pageId: 'HELP_CENTER_SCREEN',
  },
  [firebaseAnalyticsPageKeys.TRENDS_VIEW_EQUIPMENT]: {
    pageId: 'HEALTH_SUMMARY_TRENDS_TAB',
  },
  [firebaseAnalyticsPageKeys.TRENDS_VIEW_OPPORTUNITY]: {
    pageId: 'OPPORTUNITY_SUMMARY_TRENDS_TAB',
  },
  [firebaseAnalyticsPageKeys.TRENDS_VIEW]: {
    pageId: 'TRENDS_SCREEN',
  },
  [firebaseAnalyticsPageKeys.SITE_LIST]: {
    pageId: 'SITE_LIST_SCREEN',
  },
  [firebaseAnalyticsPageKeys.MAP_LIST]: {
    pageId: 'MAP_SCREEN',
  },
  [firebaseAnalyticsPageKeys.SITE_LIST_REPORT]: {
    pageId: 'SITE_LIST_LWE',
  },
  [firebaseAnalyticsPageKeys.SITE_DETAILS_AIS_ACTIVE]: {
    pageId: 'SITE_SUMMARY_SCREEN',
  },
  [firebaseAnalyticsPageKeys.SITE_DETAILS_PAI_ACTIVE]: {
    pageId: 'TODO_LIST_SCREEN',
  },
  [firebaseAnalyticsPageKeys.LIVE_CONNECT]: {
    pageId: 'LIVE_CONNECT_SCREEN',
  },
  [firebaseAnalyticsPageKeys.TEMPERATURE_AND_CONSUMPTION]: {
    pageId: 'TEMPERATURE_AND_CONSUMPTION_SCREEN',
  },
  [firebaseAnalyticsPageKeys.EQUIPMENT_DETAILS_PAI_DETAILS]: {
    pageId: 'EQUIPMENT_SCREEN',
  },
  [firebaseAnalyticsPageKeys.EQUIPMENT_DETAILS_PAI_HISTORY]: {
    pageId: 'EQUIPMENT_PAI_HISTORY_SCREEN',
  },
  [firebaseAnalyticsPageKeys.TMM]: {
    pageId: 'TMM_SCREEN',
  },
  [firebaseAnalyticsPageKeys.PDF_REPORT]: {
    pageId: 'PDF_REPORT',
  },
  [firebaseAnalyticsPageKeys.INVENTORY_REPORT]: {
    pageId: 'INVENTORY_PDF_REPORT',
  },
};

export const checkUserAccessRole = (roles, givenRole) =>
  roles?.includes(givenRole);
